import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45
  }} className={`mx-auto w-full max-w-7xl px-4 py-14 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-304" data-mp="1373za3cwoeun">
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'green' | 'gold';
};
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false,
  variant = 'green'
}: CTAButtonProps) {
  const palette = variant === 'gold' ? 'bg-brand-gold text-brand-ink hover:bg-brand-goldLight' : 'bg-brand-green text-white hover:bg-brand-greenDark';
  return <motion.a href={href} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className={`cta-shimmer relative inline-flex items-center justify-center overflow-hidden rounded-xl px-7 py-4 text-sm font-bold tracking-wide shadow-lg transition-colors ${palette} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-305" data-mp="39kj0tmcreupo">
      <span className="relative z-10" data-id="element-306" data-mp="2vjged8hurie8">{children}</span>
    </motion.a>;
}